import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReservationDetails, TablesSection } from '../model/reservation';

@Injectable({
  providedIn: 'root'
})
export class TablesApiService {

  constructor(private httpClient: HttpClient) { }

  private baseUrl = `${environment.apiUrl}/tablesPlan`;

  getTablesAvailability(restaurantId: number | string, resDetails: ReservationDetails): Observable<{ sectionsPocket: TablesSection[] }> {
    restaurantId = restaurantId.toString();
    const reservationDetails: ReservationDetails = JSON.parse(JSON.stringify(resDetails));
    reservationDetails.tmpId = undefined;
    
    return this.httpClient.post<{ sectionsPocket: TablesSection[] }>(`${this.baseUrl}/search/tablesAvailability`, { restaurantId, reservationDetails }).pipe(
      map((res: { sectionsPocket: TablesSection[] }) => {
        return res;
      })
    );
  }
}
